exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "pre[_v-30a82d1f]{margin:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-30a82d1f&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./demo/Basic.vue
 ** module id = 40
 ** module chunks = 0
 **/